import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from 'src/utils/axios/serverHelper';
import { EQM3020_R01Dto } from './Dto_EQM3020_R01';
import { EQM3020_R01Filter } from './Store_EQM3020_R01';

const baseUrl = `${config.apiUrl}/EQM3020_R01`;

export const getEQM3020_R01List = async (
	option: string, params: Partial<EQM3020_R01Filter>, listLength = 0,
) => getData<ResponseDto<EQM3020_R01Dto[]>>(`${baseUrl}/${option}`, {
	params: { ...params, listLength } as EQM3020_R01Filter,
});

export const getEQM3020_R01AllCount = async (params: Partial<EQM3020_R01Filter>) =>
	getData<ResponseDto<number>>(`${baseUrl}/allCount`, { params: params as EQM3020_R01Filter });

export const downloadExcel_EQM3020_R01 = async (params: Partial<EQM3020_R01Filter>) =>
	getData<ResponseDto<string>>(`${baseUrl}/excel`, { params: params as EQM3020_R01Filter });

export const postEQM3020_R01 = async (list: EQM3020_R01Dto[]) =>
	postData<EQM3020_R01Dto[], ResponseDto<EQM3020_R01Dto[]>>(baseUrl, list);

export const patchEQM3020_R01 = async (list: EQM3020_R01Dto[]) =>
	patchData<EQM3020_R01Dto[], ResponseDto<EQM3020_R01Dto[]>>(baseUrl, list);

export const deleteEQM3020_R01 = async (dto: EQM3020_R01Dto) =>
	deleteData<ResponseDto<void>>(baseUrl, { data: dto });

export const downloadEQM3020_R01File = async (dto: Pick<EQM3020_R01Dto, 'resultFileId'>) =>
	getData<Blob>(`${baseUrl}/file/${dto.resultFileId}`, {
		responseType: 'blob',
	});
